module.exports = __webpack_public_path__ + "img/giropay.c818a78.svg";